var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBepaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 24,
    viewBox: "0 0 90 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_190)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4724 20.2963C19.8682 20.2963 16.1357 16.5404 16.1357 11.9072L24.4724 3.51807C29.0766 3.51807 32.8091 7.27402 32.8091 11.9072C32.8091 12.6326 32.7175 13.3365 32.5455 14.0078H20.6993C21.4361 15.3321 22.8438 16.2273 24.4593 16.2273H30.656V20.2963H24.4724ZM24.4593 7.56075C26.0854 7.56075 27.5011 8.46786 28.2338 9.80661H20.6847C21.4174 8.46786 22.8331 7.56075 24.4593 7.56075Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19076 0.090332H0.0261L0 11.859V12.177C0 16.8095 3.72321 20.565 8.316 20.565C12.9088 20.565 16.632 16.8095 16.632 12.177C16.632 7.54437 12.9088 3.78896 8.316 3.78896C6.5754 3.78896 4.93146 4.46205 4.19076 5.05281V0.090332ZM8.30286 16.4965C10.6753 16.4965 12.5984 14.5566 12.5984 12.1638C12.5984 9.77085 10.6753 7.8311 8.30286 7.8311C5.93055 7.8311 4.00734 9.77085 4.00734 12.1638C4.00734 14.5566 5.93055 16.4965 8.30286 16.4965ZM89.9325 0.090332H85.7679V5.05281C85.0271 4.46205 83.3833 3.78896 81.6427 3.78896C77.0499 3.78896 73.3267 7.54437 73.3267 12.177C73.3267 16.6982 76.8731 20.384 81.3132 20.5585L89.9587 11.8587L89.9325 0.090332ZM77.3603 12.1638C77.3603 14.5566 79.2834 16.4965 81.6558 16.4965C84.0281 16.4965 85.9513 14.5566 85.9513 12.1638C85.9513 9.77085 84.0281 7.8311 81.6558 7.8311C79.2834 7.8311 77.3603 9.77085 77.3603 12.1638ZM37.8959 23.9925H33.7314L33.7052 12.2238V11.9059C33.7052 7.27331 37.4284 3.51789 42.0212 3.51789C46.614 3.51789 50.3372 7.27331 50.3372 11.9059C50.3372 16.5385 46.614 20.2939 42.0212 20.2939C40.2805 20.2939 38.6366 19.6208 37.8959 19.03V23.9925ZM42.008 7.58648C44.3804 7.58648 46.3036 9.52623 46.3036 11.9191C46.3036 14.312 44.3804 16.2518 42.008 16.2518C39.6357 16.2518 37.7125 14.312 37.7125 11.9191C37.7125 9.52623 39.6357 7.58648 42.008 7.58648ZM62.9848 20.2965H67.2045L67.2311 12.3581V11.9976C67.2311 7.3146 63.4585 3.51835 58.8047 3.51835C54.1511 3.51835 50.3785 7.3146 50.3785 11.9976C50.3785 16.6806 54.1511 20.4769 58.8047 20.4769L62.9848 16.2707V20.2965ZM58.8181 7.63113C56.4143 7.63113 54.4656 9.59207 54.4656 12.011C54.4656 14.4299 56.4143 16.3908 58.8181 16.3908C61.2219 16.3908 63.1706 14.4299 63.1706 12.011C63.1706 9.59207 61.2219 7.63113 58.8181 7.63113Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3203 7.64453H72.4543V20.2962H68.3203V7.64453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3066 0.090332H72.4435V4.2532H68.3066V0.090332Z",
    fill: "#FF8E09"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBepaid);
export default __webpack_public_path__ + "static/media/bepaid.a46cf710808df21852cc412d75d9332e.svg";
export { ForwardRef as ReactComponent };